import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    items: Array
  }

  copy(event) {
    event.preventDefault()
    
    if (this.itemsValue.length === 0) {
      alert('No items to copy')
      return
    }
    
    const text = this.itemsValue.join('\n')
    const button = event.currentTarget
    
    navigator.clipboard.writeText(text).then(() => {
      // Show success feedback
      const originalHTML = button.innerHTML
      button.innerHTML = '<i class="fa fa-check"></i>'
      button.classList.remove('btn-info')
      button.classList.add('btn-success')
      
      setTimeout(() => {
        button.innerHTML = originalHTML
        button.classList.remove('btn-success')
        button.classList.add('btn-info')
      }, 2000)
    }).catch((err) => {
      alert('Failed to copy to clipboard: ' + err)
    })
  }
}

